module.exports = __webpack_public_path__ + "static/media/importExistingCoupon.fd58cb7f.svg";